export class JobInformation {
    public constructor(init?: Partial<JobInformation>) {
        Object.assign(this, init);
    }

    poNumber: string = '';
    jobNumber: string = '';
    jobName: string = '';
    jcDept: string = '';
    vendor: string = '';
    jobType: string = '';
}
